import { Button, TextField } from '@mui/material';

import { AtLocator } from '@Components/shared/locators/AtLocator';

import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';

import { useLocalization } from '@Modal/hooks/localization/useLocalization';
import { useState } from 'react';

export const CreateLanguageContent = () => {
  const [languageName, setLanguageName] = useState('');
  const { handleCreateNewLanguage, handleShowCreateLanguageDialog } = useLocalization();

  return (
    <CreateDialogLayout>
      <TextField value={languageName} onChange={(e) => setLanguageName(e?.target?.value)} />
      <CreateDialogFooterLayout>
        <AtLocator type="button" name="Cancel">
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => handleShowCreateLanguageDialog(false)}
          >
            Cancel
          </Button>
        </AtLocator>
        <AtLocator type="button" name="Submit">
          <Button
            variant="contained"
            disabled={!languageName.length}
            onClick={() => handleCreateNewLanguage(languageName)}
          >
            Confirm
          </Button>
        </AtLocator>
      </CreateDialogFooterLayout>
    </CreateDialogLayout>
  );
};
